import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/manufacturing')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/manufacturing', ...ROUTE_META['/industries/manufacturing'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Manufacturing', path: '/industries/manufacturing' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/manufacturing', ...ROUTE_META['/industries/manufacturing'] })),
    ],
  }),
});
